import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./RescheduleSubscriptionDeliveryForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelRescheduleSubscriptionDelivery} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {showDatePicker} from "../../actions/ViewActions";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "deliveryDate");
  return errors.toJS();
}


class RescheduleSubscriptionDeliveryFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("subscriptionId", this.props.subscriptionId);

    return this.props.rescheduleSubscription(updatedValues.toJS())
      .then((response) => {
        if (response.data.rescheduleSubscription.errors.length <= 0) {
          this.props.cancelRescheduleSubscriptionDelivery();
        } else {
          let errors = createValidationErrors(response.data.rescheduleSubscription.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRescheduleSubscriptionDelivery();
  }

  handleShowDatePicker(field, date) {
    let data = fromJS(this.props.data.subscriptionRescheduleInfo);
    let unavailableDates = data.get("unavailableDates").reduce((acc, x) => {
      return acc.set(x, "Unavailable");
    }, Map()).toJS();    
    this.props.showDatePicker(field, date, { 
      disableWeekends: true, 
      unavailableDates: unavailableDates,
      notBeforeDate: data.get("notBeforeDate"),
      notAfterDate: data.get("notAfterDate"),
    });
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    const subscriptionInfo = fromJS(data.subscriptionInfo);
    let initialValues = fromJS({
      deliveryDate: subscriptionInfo.get("nextEstimatedDeliveryDate")
    })
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        showDatePicker={this.handleShowDatePicker.bind(this)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const GET_SUBSCRIPTION = gql`
  query subscriptionInfo($subscriptionId: ID!) {
    subscriptionInfo(subscriptionId: $subscriptionId) {
      nextEstimatedDeliveryDate
    }
    subscriptionRescheduleInfo(subscriptionId: $subscriptionId) {
      notBeforeDate
      notAfterDate
      unavailableDates
    }
  }
`;


const RESCHEDULE_SUBSCRIPTION = gql`
  mutation rescheduleSubscription($data: RescheduleSubscriptionInput!) {
    rescheduleSubscription(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(GET_SUBSCRIPTION, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        subscriptionId: props.subscriptionId
      }
    })
  }),
  graphql(RESCHEDULE_SUBSCRIPTION, {
    props: ({ mutate }) => ({
      rescheduleSubscription: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);


export default connect(null, {cancelRescheduleSubscriptionDelivery, showDatePicker})(withQueries(RescheduleSubscriptionDeliveryFormContainer));